import * as React from 'react';
import { Sized } from '../types';

const Analytics = ({ width = 224, height = 224 }: Sized) => (
    <svg width={width} height={height} viewBox="20 20 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M189.4 124.68C178.74 107.364 167.167 90.6269 154.73 74.54L55.66 150.66C65.6378 163.57 74.921 177.002 83.47 190.9L189.4 124.68Z"
            fill="#E6F5FF"
        />
        <path
            d="M71.4 114.9C94.596 114.9 113.4 96.096 113.4 72.9C113.4 49.7041 94.596 30.9 71.4 30.9C48.204 30.9 29.4 49.7041 29.4 72.9C29.4 96.096 48.204 114.9 71.4 114.9Z"
            fill="#E6F5FF"
        />
        <path d="M180 57.19L178.5 54.6" stroke="#1E55EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M172.99 56.45L175 54.23"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M171.52 49.56L174.26 50.78"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M177.63 46.03L177.32 49.02"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M182.87 50.75L179.93 51.37"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M39.4 116.02C41.1231 116.02 42.52 114.623 42.52 112.9C42.52 111.177 41.1231 109.78 39.4 109.78C37.6769 109.78 36.28 111.177 36.28 112.9C36.28 114.623 37.6769 116.02 39.4 116.02Z"
            fill="#85E870"
        />
        <path
            d="M127 179C128.105 179 129 178.105 129 177C129 175.895 128.105 175 127 175C125.895 175 125 175.895 125 177C125 178.105 125.895 179 127 179Z"
            fill="#3181FF"
        />
        <path
            opacity="0.15"
            d="M143 176C145.761 176 148 173.761 148 171C148 168.239 145.761 166 143 166C140.239 166 138 168.239 138 171C138 173.761 140.239 176 143 176Z"
            fill="#85E870"
        />
        <path
            d="M142 175C144.761 175 147 172.761 147 170C147 167.239 144.761 165 142 165C139.239 165 137 167.239 137 170C137 172.761 139.239 175 142 175Z"
            fill="#85E870"
        />
        <path
            opacity="0.15"
            d="M116 48C117.657 48 119 46.6569 119 45C119 43.3431 117.657 42 116 42C114.343 42 113 43.3431 113 45C113 46.6569 114.343 48 116 48Z"
            fill="#3181FF"
        />
        <path
            d="M115 47C116.657 47 118 45.6569 118 44C118 42.3431 116.657 41 115 41C113.343 41 112 42.3431 112 44C112 45.6569 113.343 47 115 47Z"
            fill="#3181FF"
        />
        <path
            d="M54.15 181.45L52.09 179.27"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M46.85 183.18L47.71 180.31"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M41.71 177.73L44.63 177.04"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M43.85 170.55L45.91 172.73"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M51.15 168.82L50.29 171.69"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M56.29 174.27L53.37 174.96"
            stroke="#192D9B"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M170 42C171.105 42 172 41.1046 172 40C172 38.8954 171.105 38 170 38C168.895 38 168 38.8954 168 40C168 41.1046 168.895 42 170 42Z"
            fill="#85E870"
        />
        <g opacity="0.3">
            <path
                opacity="0.3"
                d="M166.4 70.9H58.4C55.0863 70.9 52.4 73.5863 52.4 76.9V144.9C52.4 148.214 55.0863 150.9 58.4 150.9H166.4C169.714 150.9 172.4 148.214 172.4 144.9V76.9C172.4 73.5863 169.714 70.9 166.4 70.9Z"
                fill="#50AAFF"
            />
            <path
                opacity="0.3"
                d="M50.9 108.82H53.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M50.9 102.96H53.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M50.9 97.11H53.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M50.9 91.26H53.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M52.4 86.39V76.9C52.4 75.3087 53.0321 73.7826 54.1574 72.6574C55.2826 71.5322 56.8087 70.9 58.4 70.9H166.4C167.991 70.9 169.517 71.5322 170.643 72.6574C171.768 73.7826 172.4 75.3087 172.4 76.9V144.9C172.4 146.491 171.768 148.017 170.643 149.143C169.517 150.268 167.991 150.9 166.4 150.9H58.4C56.8087 150.9 55.2826 150.268 54.1574 149.143C53.0321 148.017 52.4 146.491 52.4 144.9V113.69"
                stroke="#50AAFF"
                strokeWidth="3"
                strokeMiterlimit="2.61"
                strokeLinecap="round"
            />
            <path opacity="0.3" d="M164.4 78.9H60.4V142.9H164.4V78.9Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M68.4 98.9V134.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M68.4 86.9V94.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M164.4 134.9V142.9H60.4V78.9H164.4V126.8"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M164.4 131.98C165.024 131.98 165.53 131.474 165.53 130.85C165.53 130.226 165.024 129.72 164.4 129.72C163.776 129.72 163.27 130.226 163.27 130.85C163.27 131.474 163.776 131.98 164.4 131.98Z"
                stroke="#50AAFF"
                strokeWidth="0.75"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.3"
                d="M174.4 156.9H50.4C48.2783 156.9 46.2434 156.057 44.7431 154.557C43.2429 153.057 42.4 151.022 42.4 148.9H182.4C182.4 151.022 181.557 153.057 180.057 154.557C178.557 156.057 176.522 156.9 174.4 156.9Z"
                fill="#50AAFF"
                stroke="#50AAFF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M124.29 152.9H100.5C99.7044 152.9 98.9413 152.584 98.3787 152.021C97.8161 151.459 97.5 150.696 97.5 149.9V149.4H127.29V149.9C127.29 150.696 126.974 151.459 126.411 152.021C125.849 152.584 125.086 152.9 124.29 152.9Z"
                fill="#50AAFF"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M112.4 76.14C112.952 76.14 113.4 75.6923 113.4 75.14C113.4 74.5877 112.952 74.14 112.4 74.14C111.848 74.14 111.4 74.5877 111.4 75.14C111.4 75.6923 111.848 76.14 112.4 76.14Z"
                fill="#50AAFF"
            />
            <path opacity="0.3" d="M89.9 128.4H77.9V136.4H89.9V128.4Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M89.9 128.4H77.9V136.4H89.9V128.4Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M88.4 126.9H76.4V134.9H88.4V126.9Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M88.4 126.9H76.4V134.9H88.4V126.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M109.9 122.4H97.9V136.4H109.9V122.4Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M109.9 122.4H97.9V136.4H109.9V122.4Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M108.4 120.9H96.4V134.9H108.4V120.9Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M108.4 120.9H96.4V134.9H108.4V120.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M129.9 112.4H117.9V136.4H129.9V112.4Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M129.9 112.4H117.9V136.4H129.9V112.4Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M128.4 110.9H116.4V134.9H128.4V110.9Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M128.4 110.9H116.4V134.9H128.4V110.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M149.9 100.4H137.9V136.4H149.9V100.4Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M149.9 100.4H137.9V136.4H149.9V100.4Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path opacity="0.3" d="M148.4 98.9H136.4V134.9H148.4V98.9Z" fill="#50AAFF" />
            <path
                opacity="0.3"
                d="M148.4 98.9H136.4V134.9H148.4V98.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M90.4 114.9C98.132 114.9 104.4 108.632 104.4 100.9C104.4 93.168 98.132 86.9 90.4 86.9C82.668 86.9 76.4 93.168 76.4 100.9C76.4 108.632 82.668 114.9 90.4 114.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.3"
                d="M90.4 86.9C93.5041 86.9015 96.5196 87.9346 98.9726 89.8368C101.425 91.7391 103.177 94.4026 103.951 97.4086C104.725 100.415 104.478 103.593 103.249 106.443C102.02 109.293 99.8787 111.655 97.1614 113.155C94.4442 114.656 91.3053 115.211 88.2382 114.733C85.1711 114.255 82.3498 112.772 80.2178 110.516C78.0858 108.26 76.764 105.359 76.4603 102.27C76.1566 99.1806 76.8882 96.0781 78.54 93.45"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.3"
                d="M76.4 100.9C76.3919 98.2639 77.1342 95.68 78.54 93.45"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.3"
                d="M90.4 110.9C95.9228 110.9 100.4 106.423 100.4 100.9C100.4 95.3772 95.9228 90.9 90.4 90.9C84.8772 90.9 80.4 95.3772 80.4 100.9C80.4 106.423 84.8772 110.9 90.4 110.9Z"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.3"
                d="M90.4 90.9C92.8602 90.8829 95.2404 91.7734 97.0853 93.4011C98.9302 95.0289 100.11 97.2796 100.4 99.7228C100.689 102.166 100.068 104.63 98.6549 106.644C97.2417 108.658 95.1356 110.08 92.7395 110.639C90.3435 111.197 87.8256 110.853 85.6675 109.671C83.5094 108.49 81.8626 106.555 81.042 104.235C80.2214 101.916 80.2847 99.3751 81.2197 97.0994C82.1547 94.8237 83.8958 92.9726 86.11 91.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.3"
                d="M80.4 100.9C80.4062 99.0141 80.9457 97.1684 81.956 95.5759C82.9663 93.9834 84.4064 92.7091 86.11 91.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <g opacity="0.3">
                <path
                    d="M144.4 56.9C150.729 56.9 156.916 58.7768 162.178 62.293C167.441 65.8092 171.542 70.8069 173.964 76.6542C176.386 82.5014 177.02 88.9355 175.785 95.1429C174.55 101.35 171.503 107.052 167.027 111.527C162.552 116.003 156.85 119.05 150.643 120.285C144.435 121.52 138.001 120.886 132.154 118.464C126.307 116.042 121.309 111.941 117.793 106.678C114.277 101.416 112.4 95.229 112.4 88.9C112.4 80.4131 115.771 72.2738 121.773 66.2726C127.774 60.2714 135.913 56.9 144.4 56.9Z"
                    fill="#50AAFF"
                />
                <path
                    d="M144.4 56.9C150.729 56.9 156.916 58.7768 162.178 62.293C167.441 65.8092 171.542 70.8069 173.964 76.6542C176.386 82.5014 177.02 88.9355 175.785 95.1429C174.55 101.35 171.503 107.052 167.027 111.527C162.552 116.003 156.85 119.05 150.643 120.285C144.435 121.52 138.001 120.886 132.154 118.464C126.307 116.042 121.309 111.941 117.793 106.678C114.277 101.416 112.4 95.229 112.4 88.9C112.4 80.4131 115.771 72.2738 121.773 66.2726C127.774 60.2714 135.913 56.9 144.4 56.9"
                    stroke="#50AAFF"
                    strokeWidth="3"
                    strokeMiterlimit="10"
                />
            </g>
            <path
                opacity="0.3"
                d="M144.4 63.9C149.345 63.9 154.178 65.3662 158.289 68.1133C162.4 70.8603 165.605 74.7648 167.497 79.3329C169.389 83.9011 169.884 88.9278 168.92 93.7773C167.955 98.6268 165.574 103.081 162.078 106.578C158.581 110.074 154.127 112.455 149.277 113.42C144.428 114.384 139.401 113.889 134.833 111.997C130.265 110.105 126.36 106.901 123.613 102.789C120.866 98.678 119.4 93.8446 119.4 88.9C119.4 82.2696 122.034 75.9108 126.722 71.2224C131.411 66.5339 137.77 63.9 144.4 63.9Z"
                fill="#50AAFF"
            />
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M141.9 95.4H125.9V127.4H141.9V95.4Z"
                    fill="#50AAFF"
                    stroke="#50AAFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.3"
                    d="M165.9 72.4H149.9V127.4H165.9V72.4Z"
                    fill="#50AAFF"
                    stroke="#50AAFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.3"
                    d="M140.4 93.9H124.4V125.9H140.4V93.9Z"
                    fill="#50AAFF"
                    stroke="#50AAFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.3"
                    d="M164.4 70.9H148.4V125.9H164.4V70.9Z"
                    fill="#50AAFF"
                    stroke="#50AAFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                opacity="0.3"
                d="M144.4 63.9C149.345 63.9 154.178 65.3662 158.289 68.1133C162.4 70.8603 165.605 74.7648 167.497 79.3329C169.389 83.9011 169.884 88.9278 168.92 93.7773C167.955 98.6268 165.574 103.081 162.078 106.578C158.581 110.074 154.127 112.455 149.277 113.42C144.428 114.384 139.401 113.889 134.833 111.997C130.265 110.105 126.36 106.901 123.613 102.789C120.866 98.678 119.4 93.8446 119.4 88.9V88.9C119.4 82.2696 122.034 75.9108 126.722 71.2224C131.411 66.5339 137.77 63.9 144.4 63.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                opacity="0.3"
                d="M126.4 88.9C126.4 84.1261 128.296 79.5478 131.672 76.1721C135.048 72.7964 139.626 70.9 144.4 70.9"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                opacity="0.3"
                d="M169.497 109.053L164.547 114.002L187.443 136.899L192.393 131.949L169.497 109.053Z"
                fill="#50AAFF"
                stroke="#50AAFF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path
            d="M163.4 67.9H55.4C52.0863 67.9 49.4 70.5863 49.4 73.9V141.9C49.4 145.214 52.0863 147.9 55.4 147.9H163.4C166.714 147.9 169.4 145.214 169.4 141.9V73.9C169.4 70.5863 166.714 67.9 163.4 67.9Z"
            fill="#BBE8FF"
        />
        <path d="M47.9 105.82H50.9" stroke="#1E55EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M47.9 99.96H50.9" stroke="#1E55EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M47.9 94.11H50.9" stroke="#1E55EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M47.9 88.26H50.9" stroke="#1E55EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M49.4 83.39V73.9C49.4 72.3087 50.0321 70.7826 51.1574 69.6574C52.2826 68.5322 53.8087 67.9 55.4 67.9H163.4C164.991 67.9 166.517 68.5322 167.643 69.6574C168.768 70.7826 169.4 72.3087 169.4 73.9V141.9C169.4 143.491 168.768 145.017 167.643 146.143C166.517 147.268 164.991 147.9 163.4 147.9H55.4C53.8087 147.9 52.2826 147.268 51.1574 146.143C50.0321 145.017 49.4 143.491 49.4 141.9V110.69"
            stroke="#1E55EB"
            strokeWidth="3"
            strokeMiterlimit="2.61"
            strokeLinecap="round"
        />
        <path d="M161.4 75.9H57.4V139.9H161.4V75.9Z" fill="#E6F5FF" />
        <path d="M65.4 95.9V131.9" stroke="#BBE8FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M65.4 83.9V91.9" stroke="#BBE8FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
            d="M161.4 131.9V139.9H57.4V75.9H161.4V123.8"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M161.4 128.98C162.024 128.98 162.53 128.474 162.53 127.85C162.53 127.226 162.024 126.72 161.4 126.72C160.776 126.72 160.27 127.226 160.27 127.85C160.27 128.474 160.776 128.98 161.4 128.98Z"
            stroke="#1E55EB"
            strokeWidth="0.75"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M171.4 153.9H47.4C45.2783 153.9 43.2434 153.057 41.7431 151.557C40.2429 150.057 39.4 148.022 39.4 145.9H179.4C179.4 148.022 178.557 150.057 177.057 151.557C175.557 153.057 173.522 153.9 171.4 153.9Z"
            fill="#BBE8FF"
            stroke="#1E55EB"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M121.29 149.9H97.5C96.7044 149.9 95.9413 149.584 95.3787 149.021C94.8161 148.459 94.5 147.696 94.5 146.9V146.4H124.29V146.9C124.29 147.696 123.974 148.459 123.411 149.021C122.849 149.584 122.086 149.9 121.29 149.9Z"
            fill="#E6F5FF"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M109.4 73.14C109.952 73.14 110.4 72.6923 110.4 72.14C110.4 71.5877 109.952 71.14 109.4 71.14C108.848 71.14 108.4 71.5877 108.4 72.14C108.4 72.6923 108.848 73.14 109.4 73.14Z"
            fill="#1E55EB"
        />
        <g opacity="0.3">
            <path opacity="0.3" d="M86.9 125.4H74.9V133.4H86.9V125.4Z" fill="#44CB67" />
            <path
                opacity="0.3"
                d="M86.9 125.4H74.9V133.4H86.9V125.4Z"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path d="M85.4 123.9H73.4V131.9H85.4V123.9Z" fill="#FCFFFB" />
        <path
            d="M85.4 123.9H73.4V131.9H85.4V123.9Z"
            stroke="#44CB67"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <g opacity="0.3">
            <path opacity="0.3" d="M106.9 119.4H94.9V133.4H106.9V119.4Z" fill="#44CB67" />
            <path
                opacity="0.3"
                d="M106.9 119.4H94.9V133.4H106.9V119.4Z"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path d="M105.4 117.9H93.4V131.9H105.4V117.9Z" fill="#F7FFF2" />
        <path
            d="M105.4 117.9H93.4V131.9H105.4V117.9Z"
            stroke="#44CB67"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <g opacity="0.3">
            <path opacity="0.3" d="M126.9 109.4H114.9V133.4H126.9V109.4Z" fill="#44CB67" />
            <path
                opacity="0.3"
                d="M126.9 109.4H114.9V133.4H126.9V109.4Z"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path d="M125.4 107.9H113.4V131.9H125.4V107.9Z" fill="#FCFFFB" />
        <path
            d="M125.4 107.9H113.4V131.9H125.4V107.9Z"
            stroke="#44CB67"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <g opacity="0.3">
            <path opacity="0.3" d="M146.9 97.4H134.9V133.4H146.9V97.4Z" fill="#44CB67" />
            <path
                opacity="0.3"
                d="M146.9 97.4H134.9V133.4H146.9V97.4Z"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <path d="M145.4 95.9H133.4V131.9H145.4V95.9Z" fill="#FCFFFB" />
        <path
            d="M145.4 95.9H133.4V131.9H145.4V95.9Z"
            stroke="#44CB67"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M87.4 111.9C95.132 111.9 101.4 105.632 101.4 97.9C101.4 90.168 95.132 83.9 87.4 83.9C79.668 83.9 73.4 90.168 73.4 97.9C73.4 105.632 79.668 111.9 87.4 111.9Z"
            stroke="#F7FFF2"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M87.4 83.9C90.5041 83.9015 93.5196 84.9346 95.9726 86.8368C98.4255 88.7391 100.177 91.4026 100.951 94.4086C101.725 97.4146 101.478 100.593 100.249 103.443C99.0201 106.293 96.8787 108.655 94.1614 110.155C91.4442 111.656 88.3053 112.211 85.2382 111.733C82.1711 111.255 79.3498 109.772 77.2178 107.516C75.0858 105.26 73.764 102.359 73.4603 99.2698C73.1566 96.1806 73.8882 93.0781 75.54 90.45"
            stroke="#44CB67"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M73.4 97.9C73.3919 95.2639 74.1342 92.68 75.54 90.45"
            stroke="#44CB67"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M87.4 107.9C92.9228 107.9 97.4 103.423 97.4 97.9C97.4 92.3772 92.9228 87.9 87.4 87.9C81.8772 87.9 77.4 92.3772 77.4 97.9C77.4 103.423 81.8772 107.9 87.4 107.9Z"
            stroke="#F7FFF2"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M87.4 87.9C89.8602 87.8829 92.2404 88.7734 94.0853 90.4011C95.9302 92.0289 97.1103 94.2796 97.3999 96.7228C97.6895 99.166 97.0682 101.63 95.6549 103.644C94.2417 105.658 92.1356 107.08 89.7395 107.639C87.3435 108.197 84.8256 107.853 82.6675 106.671C80.5094 105.49 78.8626 103.555 78.042 101.235C77.2214 98.9157 77.2847 96.3751 78.2197 94.0994C79.1547 91.8237 80.8958 89.9726 83.11 88.9"
            stroke="#44CB67"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M77.4 97.9C77.4062 96.0141 77.9457 94.1684 78.956 92.5759C79.9663 90.9834 81.4064 89.7091 83.11 88.9"
            stroke="#44CB67"
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
        />
        <path
            d="M141.4 53.9C147.729 53.9 153.916 55.7768 159.178 59.293C164.441 62.8092 168.542 67.8069 170.964 73.6542C173.386 79.5014 174.02 85.9355 172.785 92.1429C171.55 98.3503 168.503 104.052 164.027 108.527C159.552 113.003 153.85 116.05 147.643 117.285C141.435 118.52 135.001 117.886 129.154 115.464C123.307 113.042 118.309 108.941 114.793 103.678C111.277 98.4159 109.4 92.229 109.4 85.9C109.4 77.4131 112.771 69.2738 118.773 63.2726C124.774 57.2714 132.913 53.9 141.4 53.9Z"
            fill="#BBE8FF"
        />
        <path
            d="M141.4 53.9C147.729 53.9 153.916 55.7768 159.178 59.293C164.441 62.8092 168.542 67.8069 170.964 73.6542C173.386 79.5014 174.02 85.9355 172.785 92.1429C171.55 98.3503 168.503 104.052 164.027 108.527C159.552 113.003 153.85 116.05 147.643 117.285C141.435 118.52 135.001 117.886 129.154 115.464C123.307 113.042 118.309 108.941 114.793 103.678C111.277 98.4159 109.4 92.229 109.4 85.9C109.4 77.4131 112.771 69.2738 118.773 63.2726C124.774 57.2714 132.913 53.9 141.4 53.9"
            stroke="#1E55EB"
            strokeWidth="3"
            strokeMiterlimit="10"
        />
        <path
            d="M141.4 60.9C146.345 60.9 151.178 62.3662 155.289 65.1133C159.4 67.8603 162.605 71.7648 164.497 76.3329C166.389 80.9011 166.884 85.9278 165.92 90.7773C164.955 95.6268 162.574 100.081 159.078 103.578C155.581 107.074 151.127 109.455 146.277 110.42C141.428 111.384 136.401 110.889 131.833 108.997C127.265 107.105 123.36 103.901 120.613 99.7893C117.866 95.678 116.4 90.8446 116.4 85.9C116.4 79.2696 119.034 72.9108 123.722 68.2224C128.411 63.5339 134.77 60.9 141.4 60.9Z"
            fill="#E6F5FF"
        />
        <path
            d="M166.494 106.053L161.545 111.002L184.441 133.899L189.391 128.949L166.494 106.053Z"
            fill="#BBE8FF"
            stroke="#1E55EB"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M123.4 85.9C123.4 81.1261 125.296 76.5478 128.672 73.1721C132.048 69.7964 136.626 67.9 141.4 67.9"
            stroke="#BBE8FF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="115" y="59" width="53" height="53">
            <path
                d="M141.4 60.9C146.345 60.9 151.178 62.3662 155.289 65.1133C159.401 67.8603 162.605 71.7648 164.497 76.3329C166.389 80.9011 166.884 85.9278 165.92 90.7773C164.955 95.6268 162.574 100.081 159.078 103.578C155.581 107.074 151.127 109.455 146.277 110.42C141.428 111.384 136.401 110.889 131.833 108.997C127.265 107.105 123.36 103.901 120.613 99.7893C117.866 95.678 116.4 90.8446 116.4 85.9C116.4 79.2696 119.034 72.9108 123.722 68.2224C128.411 63.5339 134.77 60.9 141.4 60.9Z"
                fill="#C4C4C4"
            />
            <path
                d="M141.4 60.9C146.345 60.9 151.178 62.3662 155.289 65.1133C159.401 67.8603 162.605 71.7648 164.497 76.3329C166.389 80.9011 166.884 85.9278 165.92 90.7773C164.955 95.6268 162.574 100.081 159.078 103.578C155.581 107.074 151.127 109.455 146.277 110.42C141.428 111.384 136.401 110.889 131.833 108.997C127.265 107.105 123.36 103.901 120.613 99.7893C117.866 95.678 116.4 90.8446 116.4 85.9V85.9C116.4 79.2696 119.034 72.9108 123.722 68.2224C128.411 63.5339 134.77 60.9 141.4 60.9"
                stroke="black"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </mask>
        <g mask="url(#mask0)">
            <g opacity="0.3">
                <path
                    opacity="0.3"
                    d="M138.9 92.4H122.9V124.4H138.9V92.4Z"
                    fill="#44CB67"
                    stroke="#44CB67"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    opacity="0.3"
                    d="M162.9 69.4H146.9V124.4H162.9V69.4Z"
                    fill="#44CB67"
                    stroke="#44CB67"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M137.4 90.9H121.4V122.9H137.4V90.9Z"
                fill="#FCFFFB"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M161.4 67.9H145.4V122.9H161.4V67.9Z"
                fill="#FCFFFB"
                stroke="#44CB67"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M141.4 60.9C146.345 60.9 151.178 62.3662 155.289 65.1133C159.401 67.8603 162.605 71.7648 164.497 76.3329C166.389 80.9011 166.884 85.9278 165.92 90.7773C164.955 95.6268 162.574 100.081 159.078 103.578C155.581 107.074 151.127 109.455 146.277 110.42C141.428 111.384 136.401 110.889 131.833 108.997C127.265 107.105 123.36 103.901 120.613 99.7893C117.866 95.678 116.4 90.8446 116.4 85.9V85.9C116.4 79.2696 119.034 72.9108 123.722 68.2224C128.411 63.5339 134.77 60.9 141.4 60.9"
                stroke="#1E55EB"
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </g>
    </svg>
);

export default Analytics;
